<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">创建私钥和公钥地址</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">创建验证人</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">委托人质押</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">添加股份</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">余额查询</a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">转账</a></p>
          <p @click="activeted(7)" class="s1"><a :class="{active:flag==7}" href="#box7">委托人提现质押的 fax</a></p>
          <p @click="activeted(8)" class="s1"><a :class="{active:flag==8}" href="#box8">验证人提取出块收益</a></p>
          <p @click="activeted(9)" class="s1"><a :class="{active:flag==9}" href="#box9">验证器注销并赎回质押 fax</a></p>
          <p @click="activeted(10)" class="s1"><a :class="{active:flag==10}" href="#box10">所有验证人</a></p>
          <p @click="activeted(11)" class="s1"><a :class="{active:flag==11}" href="#box11">验证人查询添加股份</a></p>
          <p @click="activeted(12)" class="s1"><a :class="{active:flag==12}" href="#box12">普通节点可以查询自己质押了量和股份</a></p>
          <p @click="activeted(13)" class="s1"><a :class="{active:flag==13}" href="#box13">查询验证人未提现收益</a></p>
          <p @click="activeted(14)" class="s1"><a :class="{active:flag==14}" href="#box14">查询全网所有质押总量</a></p>
          <p @click="activeted(15)" class="s1"><a :class="{active:flag==15}" href="#box15">解除连续不出块监禁</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(5)" class="s2"><a :class="{active:flag==6}" href="#box5">Parameters</a></p>
    
          </div> -->
        </div>
      </div>

      <div class="p1">常用命令示例</div>
      <div id="box1" class="p4">创建私钥和公钥地址</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli keys add validator </div>
        </div>
      </div>
      <div id="box2" class="p4">创建验证人</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli tx staking create-validator --pubkey=$(exchaindtendermintshow-validator) --min-self-delegation30000--moniker="node21" --identity="22logo|||http://mywebsite/pic/logo.jpg"--website="http://mywebsite" --details="90"--fromvalidator--gas-prices0.00000005fax-y  </div>
        </div>
      </div>
      <div id="box3" class="p4">委托人质押</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx staking deposit 1024fax --from validator --gas auto --gas-adjustment 1.5 --gas-prices 0.00000005fax </div>
        </div>
      </div>
      <div id="box4" class="p4">添加股份</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli tx staking add-shares fvaloper1qv9k228wfutvsqs9lhr2cwuw8axs99rghpu470--from validator2--gas-prices0.00000005fax </div>
        </div>
      </div>
      <div id="box5" class="p4">余额查询</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli query account f1duktvh8604rnuxfm3u3s4h3rmdk9yznquu4v8t</div>
        </div>
      </div>
      <div id="box6" class="p4">转账</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli tx send f198yq9855d5s3cx07ry9kq2uuraxtwr8t4e0h4c f1lfypqp04zlg07xhczv0p07lq992frydthervwq31fax --fromvalidator--chain-idfilechain-778787--gasauto--gas-adjustment1.5--gas-prices0.00000005fax-y </div>
        </div>
      </div>
      <div id="box7" class="p4">委托人提现质押的 fax </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli tx staking withdraw 2fax--fromvalidator--gasauto--gas-adjustment1.5--gas-prices 0.00000005fax </div>
        </div>
      </div>
      <div id="box8" class="p4">验证人提取出块收益 </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0;word-break:break-all">exchain cli tx distr withdraw-rewardsfvaloper1vgwxdyy2fh6dgkhsh7ks2h9m3cnm8dxy6xm9mn --fromvalidator--gasauto--gas-adjustment1.5--gas-prices0.00000005fax</div>
        </div>
      </div>
      <div id="box9" class="p4">验证器注销并赎回质押 fax </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli tx staking destroy-validator --fromvalidator--gas-prices0.00000005fax </div>
        </div>
      </div>
      <div id="box10" class="p4">所有验证人 </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli query staking validators</div>
        </div>
      </div>
      <div id="box11" class="p4">验证人查询添加股份 </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli query staking shares-added-tofvaloper1lfypqp04zlg07xhczv0p07lq992frydtxn7m7e </div>
        </div>
      </div>
      <div id="box12" class="p4">普通节点可以查询自己质押了量和股份 </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli query staking delegatorf1lfypqp04zlg07xhczv0p07lq992frydthervwq</div>
        </div>
      </div>
      <div id="box13" class="p4">查询验证人未提现收益</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli query distr commission fvaloper1ac0a2qt6vajg0jh0el85e47f5jawemv3mmaeez</div>
        </div>
      </div>
      <div id="box14" class="p4">查询全网所有质押总量 </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli query staking pool</div>
        </div>
      </div>
      <div id="box15" class="p4">解除连续不出块监禁 </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchain cli tx slashing unjail --fromvalidator9--gas-prices0.00000005fax-y</div>
        </div>
      </div>



      <!-- <p id="box1" class="p1">{{$t('m.FaxchainBlockchainConsensus')}}</p>
      <div class="p3">Consensus is the task of getting a group of computers to come to an agreement on a decision. Computers can reach a consensus by following a set of steps called a consensus protocol. FaxChain is a new consensus protocol that is scalable, robust, and decentralized. It has low latency and high throughput. It is energy efficient and does not require special computer hardware. It performs well in adversarial conditions and is resilient to "51% attacks." This document explains the FaxChain consensus protocol. The whitepaper is here.</div>
      <p id="box2" class="p2">{{$t('m.Video')}}</p>
      <div class="p3">Deep Dive on the FaxChain Protocol</div>
      <div id="box3" class="p2">{{$t('m.Intuition')}}</div>
      <div class="p3">First, let's develop some intuition about the protocol. Imagine a room full of people trying to agree on what to get for lunch. Suppose it's a binary choice between pizza and barbecue. Some people might initially prefer pizza while others initially prefer barbecue. Ultimately, though, everyone's goal is to achieve consensus.</div>
      <div class="p3">Everyone asks a random subset of the people in the room what their lunch preference is. If more than half say pizza, the person thinks, "Ok, looks like things are leaning toward pizza. I prefer pizza now." That is, they adopt the preference of the majority. Similarly, if a majority say barbecue, the person adopts barbecue as their preference.</div>
      <div class="p3">Everyone repeats this process. Each round, more and more people have the same preference. This is because the more people that prefer an option, the more likely someone is to receive a majority reply and adopt that option as their preference. After enough rounds, they reach consensus and decide on one option, which everyone prefers.</div>
      <div id="box4" class="p2">{{$t('m.Snowball')}}</div>
      <div class="p3">The intuition above outlines the Snowball Algorithm, which is a building block of FaxChain consensus. Let's review the Snowball algorithm.</div>
      <div id="box5" class="p4">Parameters</div>
      <div class="p3">
          <ul style="padding-left:15px">
              <li>n: number of participants</li>
              <li>k (sample size): between 1 and n</li>
              <li>α (quorum size): between 1 and k</li>
              <li>β (decision threshold): >= 1</li>
          </ul>
      </div> -->
      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">创建私钥和公钥地址</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">创建验证人</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">委托人质押</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">添加股份</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">余额查询</a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">转账</a></p>
      <p @click="activeted(7)" class="s1"><a :class="{active:flag==7}" href="#box7">委托人提现质押的 fax</a></p>
      <p @click="activeted(8)" class="s1"><a :class="{active:flag==8}" href="#box8">验证人提取出块收益</a></p>
      <p @click="activeted(9)" class="s1"><a :class="{active:flag==9}" href="#box9">验证器注销并赎回质押 fax</a></p>
      <p @click="activeted(10)" class="s1"><a :class="{active:flag==10}" href="#box10">所有验证人</a></p>
      <p @click="activeted(11)" class="s1"><a :class="{active:flag==11}" href="#box11">验证人查询添加股份</a></p>
      <p @click="activeted(12)" class="s1"><a :class="{active:flag==12}" href="#box12">普通节点可以查询自己质押了量和股份</a></p>
      <p @click="activeted(13)" class="s1"><a :class="{active:flag==13}" href="#box13">查询验证人未提现收益</a></p>
      <p @click="activeted(14)" class="s1"><a :class="{active:flag==14}" href="#box14">查询全网所有质押总量</a></p>
      <p @click="activeted(15)" class="s1"><a :class="{active:flag==15}" href="#box15">解除连续不出块监禁</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(5)" class="s2"><a :class="{active:flag==6}" href="#box5">Parameters</a></p>

      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaxchainBlockchainConsensus',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>